module.exports = __webpack_public_path__ + "static/media/jewelosco.fbce5a5d.svg";